import React from "react";
import { StrictMode } from "react";
import ReactDOM from "react-dom";

import App from "./App";
import LoginContext from "./context/LoginContext";

import { ThemeProvider, theme } from "@chakra-ui/react";

const rootElement = document.getElementById("root");

function Root() {
  const [authstatus, setauthstatus] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState({});

  const login = () => {
    setauthstatus(!authstatus);
  };

  function funUserInfo(data) {
    setUserInfo(data);
  }

  return (
    <StrictMode>
      <ThemeProvider theme={theme}>
        <LoginContext.Provider
          value={{
            status: authstatus,
            login: login,
            getUserInfo: userInfo,
            userInfo: funUserInfo
          }}>
          <App />
        </LoginContext.Provider>
      </ThemeProvider>
    </StrictMode>
  );
}

ReactDOM.render(<Root />, rootElement);
